<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <b class="red">*</b>
          <span class="line-text">填报日期：</span>
        </div>
        <el-input type="text" v-model="formData.tbrq" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <!--<b class="red">*</b>-->
          <span class="line-text">营业总收入：</span>
        </div>
        <el-input type="text" v-model="formData.yyzsr" size="small" style="width: 280px" >
          <template slot="append">万元</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">税收总额：</span>
        </div>
        <el-input type="text" v-model="formData.ssze" size="small" style="width: 280px" >
          <template slot="append">万元</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">主导产业聚集度：</span>
        </div>
        <el-input type="text" v-model="formData.zdcy" size="small" style="width: 280px" >
          <template slot="append">%</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <!--<b class="red">*</b>-->
          <span class="line-text">入园企业：</span>
        </div>
        <el-input type="text" v-model="formData.ryqy" size="small" style="width: 280px" >
          <template slot="append">家</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <!--<b class="red">*</b>-->
          <span class="line-text">从业人数：</span>
        </div>
        <el-input type="text" v-model="formData.cyrs" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <!--<b class="red">*</b>-->
          <span class="line-text">科技型中小微企业：</span>
        </div>
        <el-input type="text" v-model="formData.kjqy" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <!--<b class="red">*</b>-->
          <span class="line-text">高新技术企业：</span>
        </div>
        <el-input type="text" v-model="formData.gxqy" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <!--<b class="red">*</b>-->
          <span class="line-text">规模以上企业：</span>
        </div>
        <el-input type="text" v-model="formData.gmqy" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <!--<b class="red">*</b>-->
          <span class="line-text">新增“小升规”企业：</span>
        </div>
        <el-input type="text" v-model="formData.xsgqy" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <!--<b class="red">*</b>-->
          <span class="line-text">隐形冠军企业数：</span>
        </div>
        <el-input type="text" v-model="formData.yxgj" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <!--<b class="red">*</b>-->
          <span class="line-text">股改企业数：</span>
        </div>
        <el-input type="text" v-model="formData.ggqy" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <!--<b class="red">*</b>-->
          <span class="line-text">上市(挂牌)企业数：</span>
        </div>
        <el-input type="text" v-model="formData.ssqy" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/DataServicePark'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'data-park-honor-add',
    data () {
      return {
        breadcrumb: [{
          value: '园区数据',
          name: 'data-park-basic'
        }, {
          value: '企业培育'
        }],
        mainTitle: '添加企业培育',
        subheading: '',

        formData: {
          tbrq: '',
          yyzsr: '',
          ssze: '',
          zdcy: '',
          ryqy: '',
          cyrs: '',
          kjqy: '',
          gxqy: '',
          gmqy: '',
          xsgqy: '',
          yxgj: '',
          ggqy: '',
          ssqy: '',
        },
      }
    },
    created () {

    },
    methods: {
      toManagementPage () {
        this.$router.push({
          name: 'enterprise-cultivation'
        })
      },

      // 添加
      confirm () {
        if (!this.formData.tbrq) {
          nError('请输入填报日期')
          return false
        }
        this.$axios.post(api.addEnterpriseDevelop, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('添加失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 190px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/DataServicePark/EnterpriseCultivation/EnterpriseCultivationAdd.vue